// extracted by mini-css-extract-plugin
export default {"component":"wBRrnW","active":"VHqpML","tablet":"z5GjPR","mobile":"yf1CCm","icon":"VM11rc","title":"qEVa1D"};